import { useState, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../utils/config';

export const useContracts = () => {
  const [bankContracts, setBankContracts] = useState([]);
  const [rentContracts, setRentContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBankContracts = useCallback(async (maptriksId) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/list/execute-query/mali-rapor-bsk`,
        {
          params: {
            maptriksId: parseInt(maptriksId)
          }
        },
        {
          headers: {
            'Content-Type': 'application/json',
            ...(localStorage.getItem('auth_token') && {
              'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            })
          }
        }
      );

      const apiData = response.data || [];
      const formattedContracts = apiData.map(item => ({
        id: item.id,
        name: item.ad,
        amount: item.kiraBedeli,
        startDate: item.kiraOdemeBaslangic,
        endDate: item.sozlesmeBitis,
        rate: item.artisOrani,
        active: true
      }));

      setBankContracts(formattedContracts);
      return formattedContracts;
    } catch (err) {
      console.error('Banka sözleşmeleri yükleme hatası:', err);
      setError(err);
      throw err;
    }
  }, []);

  const fetchRentContracts = useCallback(async (maptriksId) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/list/execute-query/mali-rapor-ysk`,
        {
          params: {
            maptriksId: parseInt(maptriksId)
          }
        },
        {
          headers: {
            'Content-Type': 'application/json',
            ...(localStorage.getItem('auth_token') && {
              'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            })
          }
        }
      );

      const apiData = response.data || [];
      const formattedContracts = apiData.map(item => ({
        id: item.id,
        name: item.ad,
        amount: item.kiraBedeli,
        startDate: item.sozlesme_kiraBaslangic,
        endDate: item.sozlesmeBitis,
        rate: item.artisOrani,
        paymentType: item.banka_girdikce_kira,
        active: true
      }));

      setRentContracts(formattedContracts);
      return formattedContracts;
    } catch (err) {
      console.error('Kira sözleşmeleri yükleme hatası:', err);
      setError(err);
      throw err;
    }
  }, []);

  const fetchAllContracts = useCallback(async (maptriksId) => {
    setLoading(true);
    setError(null);
    try {
      const [bankData, rentData] = await Promise.all([
        fetchBankContracts(maptriksId),
        fetchRentContracts(maptriksId)
      ]);
      return { bankContracts: bankData, rentContracts: rentData };
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [fetchBankContracts, fetchRentContracts]);

  return {
    bankContracts,
    rentContracts,
    loading,
    error,
    fetchBankContracts,
    fetchRentContracts,
    fetchAllContracts,
    setBankContracts,
    setRentContracts
  };
};
